import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ComponentsModule} from '../components/components.module';
import {TranslateModule} from '@ngx-translate/core';
import {SocialListComponent} from './social-list/social-list.component';
import {SocialRoutingModule} from './social-routing.module';
import {SocialItemComponent} from "./social-list/social-item/social-item.component";
import {SkeletonSocialComponent} from "./skeleton/skeleton-social.component";
import {SocialPageComponent} from './social-page/social-page.component';
import {PipesModule} from '../../pipes/pipes.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        SocialRoutingModule,
        ComponentsModule,
        PipesModule,
        TranslateModule.forChild()
    ],
    declarations: [
        SocialPageComponent,
        SocialListComponent,
        SocialItemComponent,
        SkeletonSocialComponent
    ]
})
export class SocialModule {
}
